import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import styles from "./styles.module.css";
import { Autocomplete, Box, Button, DialogActions, DialogContent, Grid, TextField } from "@mui/material";
import GenericYearMonthPicker from "../../components/GenericYearMonthPicker";

const IncidenciasVerbaManualFormSchema = z
  .object({
    inivalid: z.date(),
    id_esocial_tipo_incidencia_verba: z.number(),
  })
  .required({
    inivalid: true,
    id_esocial_tipo_incidencia_verba: true,
  });

type IncidenciasVerbaManualFormData = z.infer<typeof IncidenciasVerbaManualFormSchema>;

type IncidenciasVerbaManualFormProps = {
  incidenciasVerbaManualValues: IncidenciasVerbaManualFormData;
  onSubmit(data: IncidenciasVerbaManualFormData): void;
  onClose(event: any): void;
};

const options = [
  { id: 1, label: 'Sim' },
  { id: 2, label: 'Não' },
  { id: 3, label: 'Nunca' },
]

export default function IncidenciasVerbaManualForm({
  incidenciasVerbaManualValues,
  onSubmit,
  onClose,
}: IncidenciasVerbaManualFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<IncidenciasVerbaManualFormData>({
    mode: "onChange",
    resolver: zodResolver(IncidenciasVerbaManualFormSchema),
    defaultValues: {
      inivalid: incidenciasVerbaManualValues.inivalid,
      id_esocial_tipo_incidencia_verba: incidenciasVerbaManualValues.id_esocial_tipo_incidencia_verba,
    },
  });

  const handleCloseForm = (event: any) => {
    onClose(event);
  };

  const handleAutoCompleteChange = (event: any) => {
    setValue("id_esocial_tipo_incidencia_verba", event?.id);
  }

  const submit = (data: IncidenciasVerbaManualFormData) => {
    const body: any = {
      incidenciasVerbaManual: {
        inivalid: data.inivalid,
        id_esocial_tipo_incidencia_verba: data.id_esocial_tipo_incidencia_verba,
      },
    };

    onSubmit(body);
  };

  return (
    <form onSubmit={handleSubmit(submit)} className={styles.formDiv}>
      <DialogContent className={styles.formContainer}>
        <Box className={styles.formContent}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Controller
                name="inivalid"
                control={control}
                defaultValue={incidenciasVerbaManualValues.inivalid}
                render={({ field: { ref, ...field } }) => (
                  <GenericYearMonthPicker
                    label="Início Validade"
                    placeholder="Selecione a data"
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="id_esocial_tipo_incidencia_verba"
                control={control}
                defaultValue={incidenciasVerbaManualValues.id_esocial_tipo_incidencia_verba}
                render={({ field: { ref, onChange, ...field } }) => (
                  <Autocomplete
                    renderInput={(params) => <TextField {...params} label="Tipo Incidência" />}
                    options={options}
                    size={"small"}
                    value={options.find(item => item.id === incidenciasVerbaManualValues.id_esocial_tipo_incidencia_verba)}
                    onChange={(_, value) => handleAutoCompleteChange(value)}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <DialogActions className={styles.botoesPopupGeral}>
            <Button
              className={styles.botaoPopupCancelar}
              onClick={handleCloseForm}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              className={styles.botaoPopupSalvar}
              type="submit"
              color="primary"
              size="small"
            >
              Salvar
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </form>
  );
}
